import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.15833 13.825L10.975 10L7.15833 6.175L8.33333 5L13.3333 10L8.33333 15L7.15833 13.825Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgKeyboardArrowRight);
export default ForwardRef;
